import { useTranslation } from 'react-i18next';
import usePageParam from '../../hooks/usePageParam';
import InstagramEmbedComponent from '../../components/InstagramEmbedComponent';

import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';
import Pagination from '../../components/Pagination';

const posts = [
  { postId: 'Dbh-0oiDT4D' },
  { postId: 'DbOV66VDTuI' },
  { postId: 'DaqDMRQDSiz' },
  { postId: 'DaYMY9QDQ1j' },
  { postId: 'DaIAd01DQtn' },
  { postId: 'DZ0asjsjTu1' },
  { postId: 'DZirqsyjSQv' },
  { postId: 'DZQWQllDYLV' },
  { postId: 'DY-ainsDT81' },
  { postId: 'DYsaWsYDTpF' },
  { postId: 'DYIME6tDerN' },
  { postId: 'DXl_0lcjaoE' },
  { postId: 'DXSUNO1jYnm' },
  { postId: 'DXC2o2ijfms' },
  { postId: 'DWudOZPja74' },
  { postId: 'DWNEmbwCA0S' },
  { postId: 'DV4NB7mjXEV' },
  { postId: 'DVnzMDbjUIB' },
  { postId: 'DVWzfyZDfpZ' },
  { postId: 'DVCQcO0jQiH' },
  { postId: 'DUyEJI7CPSQ' },
  { postId: 'DUNjqz-DSsX' },
  { postId: 'DT6KFAwDbTM' },
  { postId: 'DTpbBnhjSk2' },
  { postId: 'DSTBEciDaRG' },
  { postId: 'DRxQszGDbZs' },
  { postId: 'DRFyqNEDbrM' },
  { postId: 'DQjZ2U_jezz' },
  { postId: 'DQRf79RDUc6' },
  { postId: 'DQJLK0EDeuQ' },
  { postId: 'DPtL2sdDcnP' },
  { postId: 'DPbIQwCDT5J' },
  { postId: 'DPJgQnoCBfN' },
  { postId: 'DOTT1jYiCkO' },
  { postId: 'DNvIzdyWkJr' },
  { postId: 'DNd5qkHNU-Q' },
  { postId: 'DNJhsC0txuj' },
  { postId: 'DM5jgzftyMa' },
  { postId: 'DMnLkjttucg' },
  { postId: 'DMVdg99NkAr' },
  { postId: 'DMDCqgQt14p' },
  { postId: 'DLvQSrjNhXn' },
  { postId: 'DLern9ktKv3' },
  { postId: 'DLNyBBdNVOF' },
  { postId: 'DK9fFd0Nu4I' },
  { postId: 'DKsZNCXtb2P' },
];
function Volunteer() {
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = usePageParam(1);
  const itemsPerPage = 12;

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedPosts = posts.slice(startIndex, endIndex);

  return (
    <div>
      <PageHeader
        title={t('volunteerPage.title')}
        page={t('volunteerPage.page')}
        pageUrl={'volunteer'}
      />

      <div id="blog-home" className="page">
        <div className="container block-padding pt-0 pb-0">
          <div className="col-lg-8 offset-lg-2 text-center">
            <h2>{t('volunteerPage.intro')}</h2>
            <p>{t('volunteerPage.description')}</p>
            <h5>{t('volunteerPage.photos')}</h5>
          </div>
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-11">
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                  padding: '16px',
                  columnGap: '20px',
                }}
              >
                {paginatedPosts.map(p => (
                  <div
                    key={p.postId}
                    style={{
                      width: '100%',
                      padding: '20px',
                      boxSizing: 'border-box',
                    }}
                  >
                    <InstagramEmbedComponent postId={p.postId} />
                  </div>
                ))}
              </div>
              {/* ))} */}
              <div className="col-md-12 mt-5">
                <Pagination
                  page={currentPage}
                  totalItems={posts.length}
                  itemsPerPage={itemsPerPage}
                  onPageChange={setCurrentPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Volunteer;
